import { GetterTree } from 'vuex';
import { RootState, ListStatus } from '@/store/types';
import { BannerStandOrdersState } from './types';

export const getters: GetterTree<BannerStandOrdersState, RootState> = {
  listIsLoading: (state) => state.listStatus === ListStatus.Loading,
  listIsLoaded: (state) => state.listStatus === ListStatus.Loaded,
  listIsEmpty: (state) => state.list.length === 0,
};

export default getters;
